<template>
    <div class="row" v-if="1 === page && 0 === selection.length">
        <template v-for="(p, i) in products">
            <div class="col-12 col-sm-6 col-lg-4">
                <ponroy-product-card
                        :id="p.id"
                        :title="p.title"
                        :isNewFormula="false"
                        :isNew="false"
                        :bestSales="false"
                        :provenSatisfaction="false"
                        :isRecommended="true"
                        :url="p.url"
                        :cardImage="p.cardImage"
                        :shortDescription="p.shortDescription"
                        :subtitle="p.subtitle"
                        :references="p.references"
                        :lowestPrice="p.lowestPrice"
                        :lowestBasePrice="p.lowestBasePrice"
                        :reviews="p.reviews"
                        :reviewsAvg="p.reviewsAvg"
                        :widgetId="widgetId"
                        :available="!p.unavailable"
                        repository="site.repository.product_reference"
                ></ponroy-product-card>
            </div>

        </template>
    </div>
</template>

<script>
    import Routing from 'routing';
    import PonroyProductCard from './ProductCard.vue';

    import {mapState, mapActions, mapGetters} from 'vuex';
    import store from '../store';

    export default {
        name: 'ponroy-product-recommendation',
        store,
        components: {
            PonroyProductCard,
            Routing
        },
        props: {
            products: {
                type: Array,
                required: false,
            },
            widgetId: {
                type: String,
                required: false,
            }
        },
        computed: {
            ...mapState('facetedFilter', [
                'page'
            ]),
            ...mapGetters('facetedFilter', [
                'selection',
            ])
        },
    };
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/ProductRecommendation.vue